import { map } from 'rxjs/operators';
import { AfterViewInit, Component, ElementRef, forwardRef, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { GwrGemeindeEntry, GwrgemeindeService } from 'app/core/gwr-api';
import { ComparatorService } from '../../../shared/services/comparator-service';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { AbstractTypeaheadSearch } from '../../../shared/components/typeahead-search/abstract-typeahead-search';
import { MetaDisablerDirective } from '../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../shared/directives/meta-validator.directive';

@Component({
  selector: 'cap-gwr-gemeinde',
  templateUrl: './gwr-gemeinde.component.html',
  styleUrls: ['./gwr-gemeinde.component.scss'],
  host: {
    class: 'form-control-component'
  },
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => GwrGemeindeComponent), multi: true }],
  imports: [FormsModule, NgbTypeahead, MetaDisablerDirective, MetaValidatorDirective]
})
export class GwrGemeindeComponent extends AbstractTypeaheadSearch<GwrGemeindeEntry> implements OnInit, AfterViewInit, ControlValueAccessor {
  model: GwrGemeindeEntry;

  private reset = false;

  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;

  propagateChange: (gemeinde: GwrGemeindeEntry) => void;
  propagateTouch: (_) => void;

  constructor(
    private gwrgemeindeService: GwrgemeindeService,
    private comparatorService: ComparatorService
  ) {
    super();
  }

  ngOnInit() {
    const findAll = this.gwrgemeindeService
      .getGemeindeAll()
      .pipe(map((response: Array<GwrGemeindeEntry>) => response.sort((a, b) => this.sortByName(a, b))));
    this.setSearch(findAll);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    });
  }

  writeValue(entry: GwrGemeindeEntry): void {
    if (entry?.name && entry?.bfsNummer) {
      this.value = entry.name + ' ' + entry.bfsNummer;
      this.selectedItem = entry;
      this.model = entry;
      this.reset = false;
      this.propagateChange(entry);
    } else if (!this.reset) {
      this.reset = true;
      this.onClear();
    }
  }

  sortByName(a: GwrGemeindeEntry, b: GwrGemeindeEntry) {
    return this.comparatorService.orderByComparator(a.name, b.name);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  onSelected($event: NgbTypeaheadSelectItemEvent<GwrGemeindeEntry>) {
    const selectedItem = $event.item;
    if (selectedItem) {
      this.value = this.formatEntry(selectedItem);
      this.model = selectedItem;
      this.propagateChange(selectedItem);
      this.reset = false;
    } else {
      this.value = '';
      this.model = null;
      this.propagateChange(null);
    }
  }

  public onClear() {
    super.onClear();
    this.model = null;
  }

  formatEntry(entry: GwrGemeindeEntry): string {
    if (entry?.name && entry?.bfsNummer) {
      return entry.name + ' ' + entry.bfsNummer;
    } else if (entry?.name) {
      return entry.name;
    }
    return '';
  }
}
